module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/artistar-677918c369b6ee9dcb2b4a36743d7f83.png";